import { ImageInfo } from '../store/types';

export const convertImageListToTable = (items: ImageInfo[]) => (
  items.map((item) => ({
    key: item.id,
    ...item
  }))
);
